export default {
      id: "oc-arrow-right-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-arrow-right",
      toString: function () {
        return this.url;
      }
    }